export const habitaciones = [
  {
    id: 1,
    tipo: 'Habitación Matrimonial',
    nombre: 'Habitación Familiar con baño privado',
    descripcion: 'Habitación con cama matrimonial y una cama individual, baño privado, tv, calefacción, wifi, toallas, cocina compartida',
    capacidad: 3,
    precio: 45000, // Precio base para máxima ocupación
    preciosPorOcupacion: {
      1: 33000, // Precio para 1 persona
      2: 40000, // Precio para 2 personas
      3: 45000  // Precio para 3 personas (capacidad completa)
    },
    imagen: '/images/habitaciones/habitacion1.jpg',
    imagenes: [
      '/images/habitaciones/habitacion1.jpg',
      '/images/habitaciones/habitacion1_2.jpg',
      '/images/habitaciones/habitacion1_3.jpg'
    ]
  },
  {
    id: 7,
    tipo: 'Doble',
    nombre: 'Habitación dos camas con baño privado',
    descripcion: 'Habitación con dos camas individuales y baño privado, tv, calefacción, wifi, toallas, cocina compartida',
    capacidad: 2,
    precio: 40000, // Precio base para máxima ocupación
    preciosPorOcupacion: {
      1: 33000, // Precio para 1 persona
      2: 40000  // Precio para 2 personas (capacidad completa)
    },
    imagen: '/images/habitaciones/habitacion2.jpeg',
    imagenes: [
      '/images/habitaciones/habitacion2.jpeg',
      '/images/habitaciones/habitacion2_2.jpg',
      '/images/habitaciones/habitacion2_3.jpeg'
    ]
  },
  {
    id: 3,
    tipo: 'Habitacion privada con baños compartidos',
    nombre: 'Habitación con 2 camas individuales y baños compartidos',
    descripcion: 'Habitación con dos camas individuales y baño compartido, tv, wifi, toallas, cocina compartida',
    capacidad: 2,
    precio: 33000, // Precio base para máxima ocupación
    preciosPorOcupacion: {
      1: 23000, // Precio para 1 persona
      2: 33000  // Precio para 2 personas (capacidad completa)
    },
    imagen: '/images/habitaciones/habitacion3.jpg',
    imagenes: [
      '/images/habitaciones/habitacion3.jpg',
      '/images/habitaciones/habitacion3_2.jpg'
    ]
  },
  {
    id: 8,
    tipo: 'Habitacion privada con baños compartidos',
    nombre: 'Habitación con 2 camas individuales y baños compartidos',
    descripcion: 'Habitación con dos camas individuales y baños compartidos, wifi, toallas, cocina compartida',
    capacidad: 2,
    precio: 33000, // Precio base para máxima ocupación
    preciosPorOcupacion: {
      1: 23000, // Precio para 1 persona
      2: 33000  // Precio para 2 personas (capacidad completa)
    },
    imagen: '/images/habitaciones/habitacion4.jpg',
    imagenes: [
      '/images/habitaciones/habitacion4.jpg',
      '/images/habitaciones/habitacion4_2.jpg'
    ]
  },
  {
    id: 6,
    tipo: 'Habitación Matrimonial',
    nombre: 'Habitación Matrimonial con baño privado',
    descripcion: 'Habitación con cama matrimonial, baño privado, tv, calefacción, wifi, toallas, cocina compartida',
    capacidad: 2,
    precio: 40000, // Precio base para máxima ocupación
    preciosPorOcupacion: {
      1: 33000, // Precio para 1 persona
      2: 40000 // Precio para 2 personas
    },
    imagen: '/images/habitaciones/habitacion5.jpg',
    imagenes: [
      '/images/habitaciones/habitacion5.jpg',
      '/images/habitaciones/habitacion5_2.jpeg'
    ]
  },
  {
    id: 2,
    tipo: 'Literas',
    nombre: 'Habitación con Literas y baños compartidos',
    descripcion: 'Habitación con dos literas, ideal para familias o grupos, wifi, toallas, cocina compartida',
    capacidad: 4,
    precio: 60000, // Precio base para máxima ocupación
    preciosPorOcupacion: {
      1: 23000, // Precio para 1 persona
      2: 33000, // Precio para 2 personas
      3: 45000, // Precio para 3 personas
      4: 60000  // Precio para 4 personas (capacidad completa)
    },
    imagen: '/images/habitaciones/habitacion6.jpg',
    imagenes: [
      '/images/habitaciones/habitacion6.jpg',
      '/images/habitaciones/habitacion6_2.jpg'
    ]
  },
  {
    id: 5,
    tipo: 'Individual',
    nombre: 'Habitación Individual con baños compartidos',
    descripcion: 'Habitación con individual, baños compartidos, wifi, toallas, cocina compartida',
    capacidad: 1,
    precio: 23000, // Precio base para máxima ocupación
    preciosPorOcupacion: {
      1: 23000 // Precio para 1 persona
    },
    imagen: '/images/habitaciones/habitacion7.png',
    imagenes: [
      '/images/habitaciones/habitacion7.png',
      '/images/habitaciones/habitacion7_2.jpg'
    ]
  }
];

// Datos de ejemplo para reservaciones existentes
export const reservaciones = [
  {
    habitacionId: 1,
    fechaEntrada: '2024-03-15',
    fechaSalida: '2024-03-20'
  },
  {
    habitacionId: 3,
    fechaEntrada: '2024-03-18',
    fechaSalida: '2024-03-25'
  },
  {
    habitacionId: 5,
    fechaEntrada: '2024-03-22',
    fechaSalida: '2024-03-28'
  }
]; 